import { Form, InputGroup } from "react-bootstrap";

import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";

export const SimpleConsumptionComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();
  if (hidden) return null;

  return (
    <div className="sales-doc-field mb-3">
      <hr className="sales-doc-divider" />
      <span id={`meter-${meter.id.toString()}-unit-rate-label`} className="sales-doc-group-label">
        Unit Rate
      </span>

      <div role="group" aria-labelledby={`meter-${meter.id.toString()}-unit-rate-label`}>
        <div
          className={`input-group mb-1${ctx.lockedFields.has("dayRate") ? " read-only-field" : ""}`}
        >
          <span className="input-group-text">Rate</span>
          <input
            type="number"
            min="0"
            step="0.00001"
            className="form-control"
            value={ctx.dayRate.rate}
            onChange={(e) => {
              ctx.setDayRate({ ...ctx.dayRate, rate: e.target.value });
            }}
            required
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text">Consumption</span>
          <input
            type="number"
            min="0"
            step="0.00001"
            className="form-control"
            value={ctx.dayRate.consumption}
            onChange={(e) => {
              ctx.setDayRate({ ...ctx.dayRate, consumption: e.target.value });
            }}
            required
          />
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor={`meter-${meter.id.toString()}-estimated-annual-cost`}>Estimated Cost</label>
        <InputGroup>
          <InputGroup.Text>£</InputGroup.Text>
          <Form.Control
            type="number"
            min="0"
            step="0.00001"
            className="form-control"
            id={`meter-${meter.id.toString()}-estimated-annual-cost`}
            value={ctx.estimatedAnnualCost}
            onChange={(e) => {
              ctx.handleEstimatedAnnualCostChange(e.target.value);
            }}
            required
          />
        </InputGroup>
      </div>

      <div className="mb-3 form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          id={`manual-calculation-${meter.id.toString()}`}
          checked={ctx.manualCalculation}
          onChange={(e) => {
            ctx.setManualCalculation(e.target.checked);
          }}
        />
        <label className="form-check-label" htmlFor={`manual-calculation-${meter.id.toString()}`}>
          Manual Calculation
        </label>
      </div>
    </div>
  );
};
